import React from "react";
import Container from "../Components/Container";
import TitleSection from "../Components/TitleSection";
import EventSummary from "../Components/EventSummary";
import { LoadingButton } from "@mui/lab";
import { Button, Stack } from "@mui/material";
import { ArrowLeft, CalendarDots } from "@phosphor-icons/react";
import { STEPS } from "../utils";
import { useRescheduling } from "../ReschedulingProvider";
import useRescheduleVideoCall from "hooks/api/appointments/useRescheduleVideoCall";
import { addMinutes } from "date-fns";
import { formatRepeatDays } from "components/EventScheduling/EventSchedulingUtils";

export default function RescheduleReview() {
  const { onBack, setStep, callInfo, newAppointmentTime } = useRescheduling();
  const { isRescheduleVideoCallLoading, rescheduleVideoCall } = useRescheduleVideoCall();

  const handleReschedule = () => {
    const payload = {
      startDate: newAppointmentTime,
      endDate: addMinutes(new Date(newAppointmentTime), callInfo.call_duration),
      clinicianUserId: callInfo.primary_clinician_user_id || callInfo.clinician_user_id,
      secondaryClinicianUserId: callInfo.secondary_clinician_user_id,
      repeatDays: formatRepeatDays(callInfo.repeat_days),
      overrideSchedule: true,
      repeatEndType: callInfo.repeat_type,
      repeatUntilDate: callInfo.repeat_until_date,
      timeUnit: callInfo.time_unit,
      timeInterval: callInfo.time_interval,
      isRepeating: callInfo.is_recurring,
      memberId: callInfo.client_user_id,
      isTentative: false,
      rescheduleAllInstances: false,
      timezone: callInfo.call_timezone,
      videoId: callInfo.id,
      offPlatform: callInfo.off_platform,
      billingType: callInfo.billing_type,
    };
    rescheduleVideoCall(payload, { onSuccess: () => setStep(STEPS.rescheduleConfirmation) });
  };
  return (
    <Container onBack={onBack}>
      <TitleSection
        title={"Review your new appointment."}
        subtitle="Let’s confirm everything looks correct."
      />
      <EventSummary highlightText="New Appointment Time" />
      <Stack gap={3}>
        <LoadingButton
          loading={isRescheduleVideoCallLoading}
          size="large"
          startIcon={<CalendarDots />}
          onClick={handleReschedule}
        >
          Book Appointment
        </LoadingButton>
        <Button
          size="large"
          variant="text"
          color="secondary"
          onClick={onBack}
          startIcon={<ArrowLeft />}
        >
          Back
        </Button>
      </Stack>
    </Container>
  );
}
